"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _constants = require("../utils/constants");

var _ChoiceBuilderItem = _interopRequireDefault(require("./ChoiceBuilderItem"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var propKeys = {
  choices: 'component.props.choices'
};

var ChoiceBuilder = function ChoiceBuilder(_ref) {
  var questionId = _ref.questionId,
      choices = _ref.choices,
      setQuestion = _ref.setQuestion,
      setBranchFrom = _ref.setBranchFrom,
      activeConditions = _ref.activeConditions,
      removedChoice = _ref.removedChoice,
      errors = _ref.errors;

  var _useState = (0, _react.useState)(new Map()),
      uploadErrors = _useState[0],
      setUploadErrors = _useState[1];

  var setFileUploadError = function setFileUploadError(id, error) {
    return setUploadErrors(new Map(uploadErrors.set(id, error)));
  };

  var clearFileUploadErrors = function clearFileUploadErrors() {
    uploadErrors.clear();
    setUploadErrors(new Map());
  };

  var onAddImage = function onAddImage(e, id) {
    clearFileUploadErrors();
    var image = {};
    var files = e.target.files;

    if (files.length > 1) {
      setFileUploadError(id, 'You can upload only one image per choice option.');
    } else {
      var file = files[0];

      if (file && file.size < _constants.MAX_FILE_SIZE_BYTES) {
        switch (file.type) {
          case _constants.FILE_TYPE_IMAGE_PNG:
          case _constants.FILE_TYPE_IMAGE_JPEG:
          case _constants.FILE_TYPE_IMAGE_JPG:
          case _constants.FILE_TYPE_IMAGE_GIF:
            image = {
              fileName: file.name,
              type: file.type,
              url: URL.createObjectURL(file)
            };
            break;

          default:
            {
              setFileUploadError(id, 'Unsupported image format. Please upload a valid PNG/JPEG/JPG/GIF file.');
              break;
            }
        }
      } else {
        setFileUploadError(id, 'The uploaded image exceeds the maximum permitted size (8 MB).');
      }
    }

    e.target.value = '';
    var choice = choices == null ? void 0 : choices.find(function (x) {
      return x.id === id;
    });

    if (choice) {
      choice.image = image;
    } else {
      setFileUploadError(id, 'Error in image upload. Please try again.');
    }

    setQuestion(choices, propKeys.choices);
  };

  var onRemoveImage = function onRemoveImage(id) {
    clearFileUploadErrors();
    var choice = choices.find(function (x) {
      return x.id === id;
    });

    if (choice) {
      choice.image = {};
    }

    setQuestion(choices, propKeys.choices);
  };

  var add = function add() {
    clearFileUploadErrors();
    setQuestion([].concat(choices, [{
      id: (0, _uuid.v1)(),
      value: '',
      image: {}
    }]), propKeys.choices);
  };

  var remove = function remove(id) {
    clearFileUploadErrors();

    if (choices.length === 1) {
      setQuestion(false);
    }

    removedChoice(id, questionId);
    setQuestion([].concat(choices.filter(function (x) {
      return x.id !== id;
    })), propKeys.choices);
  };

  var move = function move(order, id, direction) {
    clearFileUploadErrors();
    var copy = choices;
    var swapIndex = direction === _constants.moveDirections.up ? parseInt(order) - 1 : parseInt(order) + 1;
    var toMove = copy[order];
    copy[order] = copy[swapIndex];
    copy[swapIndex] = toMove;
    setQuestion([].concat(copy), propKeys.choices);
  };

  var set = function set(order, id, value) {
    clearFileUploadErrors();
    var copy = choices;
    copy[order] = Object.assign({}, copy.find(function (x) {
      return x.id === id;
    }), {
      value: value
    });
    setQuestion([].concat(copy), propKeys.choices);
  };

  var getActiveCondition = function getActiveCondition(value) {
    if (!activeConditions) return [];
    if (activeConditions.length === 0) return [];
    var matches = activeConditions.filter(function (x) {
      return x.value === value;
    });
    return matches;
  };

  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, choices.map(function (choice, i) {
    var _errors$choices;

    return /*#__PURE__*/_react.default.createElement(_ChoiceBuilderItem.default, _extends({}, choice, {
      key: questionId + "-" + choice.id + "-" + i,
      order: i,
      questionId: questionId,
      setValue: set,
      remove: remove,
      move: move,
      image: choice.image,
      onAddImage: onAddImage,
      moveUpDisabled: i === 0,
      moveDownDisabled: i === choices.length - 1,
      setBranchFrom: setBranchFrom,
      activeCondition: getActiveCondition(choice.id).length > 0 ? getActiveCondition(choice.id)[0] : {},
      error: (errors == null ? void 0 : (_errors$choices = errors.choices) == null ? void 0 : _errors$choices.some(function (x) {
        return x === choice.id;
      })) && errors.error || uploadErrors.get(choice.id),
      onRemoveImage: onRemoveImage
    }));
  }), /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    error: errors && !(errors != null && errors.choices) && errors.error
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: add,
    className: "ln-u-margin-ends"
  }, "Add option"))));
};

ChoiceBuilder.propTypes = {
  /** The unique identifier of the question */
  questionId: _propTypes.default.string.isRequired,

  /** The list of choices */
  choices: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the choice */
    id: _propTypes.default.string,

    /** The value of the choice */
    value: _propTypes.default.string,
    image: _propTypes.default.shape({
      fileName: _propTypes.default.string,
      url: _propTypes.default.string,
      type: _propTypes.default.string
    })
  })),

  /** Function to update the values of the question object */
  setQuestion: _propTypes.default.func.isRequired,

  /** Function to set the question/value combination for branching questions */
  setBranchFrom: _propTypes.default.func.isRequired,

  /** A list of conditions that are linked to the question */
  activeConditions: _propTypes.default.array,

  /** Function to handle removed items and removing any linked branches */
  removedChoice: _propTypes.default.func.isRequired,

  /** Validation errors that are linked to the question */
  errors: _propTypes.default.object
};
ChoiceBuilder.defaultProps = {
  choices: [],
  activeConditions: [],
  errors: null
};
var _default = ChoiceBuilder;
exports.default = _default;